export default {
  path: 'settings',
  name: 'settings',
  component: () => import('@/views/settings/index.vue'),
  meta: {
    locale: '系统设置',
    requiresAuth: true,
    icon: 'icon-settings',
  },
  children: [
    {
      path: 'settings-list',
      name: 'settings-list',
      component: () => import('@/views/settings/list/index.vue'),
      meta: {
        locale: '系统设置',
        requiresAuth: true,
        roles: ['super', 'admin'],
      },
    },
    {
      path: 'permission-config',
      name: 'permission-config',
      component: () => import('@/views/permission-config/list/index.vue'),
      meta: {
        locale: '权限管理',
        requiresAuth: true,
        roles: ['super', 'admin'],
      },
    },
    {
      path: 'level-config',
      name: 'level-config',
      component: () => import('@/views/level-config/index.vue'),
      meta: {
        locale: '等级配置',
        requiresAuth: true,
        roles: ['super', 'admin'],
      },
    },
  ],
};
